var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c(
        "button",
        {
          staticClass: "navbar-toggler d-lg-none p-3",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.toggleMobileNav(false)
            }
          }
        },
        [
          _vm.darkHeaderActive
            ? [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "19",
                      height: "19",
                      viewBox: "0 0 38 38"
                    }
                  },
                  [
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            fill: "none",
                            stroke: "#BAC4CC",
                            "stroke-miterlimit": "20",
                            "stroke-width": "3",
                            d: "M1.107 1.388l35.409 35.409"
                          }
                        })
                      ]),
                      _c("g", [
                        _c("path", {
                          attrs: {
                            fill: "none",
                            stroke: "#BAC4CC",
                            "stroke-miterlimit": "20",
                            "stroke-width": "3",
                            d: "M1.107 36.796L36.516 1.387"
                          }
                        })
                      ])
                    ])
                  ]
                )
              ]
            : [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "19",
                      height: "19",
                      viewBox: "0 0 38 38"
                    }
                  },
                  [
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            fill: "none",
                            stroke: "#3a4c53",
                            "stroke-miterlimit": "20",
                            "stroke-width": "3",
                            d: "M1.107 1.388l35.409 35.409"
                          }
                        })
                      ]),
                      _c("g", [
                        _c("path", {
                          attrs: {
                            fill: "none",
                            stroke: "#3a4c53",
                            "stroke-miterlimit": "20",
                            "stroke-width": "3",
                            d: "M1.107 36.796L36.516 1.387"
                          }
                        })
                      ])
                    ])
                  ]
                )
              ]
        ],
        2
      )
    : _c(
        "button",
        {
          staticClass: "navbar-toggler d-lg-none p-3",
          class: { "navbar-toggler--dark": _vm.darkHeaderActive },
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.toggleMobileNav(true)
            }
          }
        },
        [_vm._v("\n    ☰\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }